import React from 'react';
import Base from '../../base';
import { Button, TextCopy } from 'components';
import { Props } from 'types/modals';

const RevealSSNModal = ({ closing, onClose, params }: Props) => {
  const ssn: string = params?.ssn ?? '';

  return (
    <Base
      header="Reveal SSN"
      closing={closing}
      onClose={onClose}
      size="sm"
      footer={<Button text="Close" variant="secondary" onClick={() => onClose()} />}
    >
      <div className="body-1" style={{ display: 'flex', justifyContent: 'center' }}>
        <TextCopy value={ssn} />
      </div>
    </Base>
  );
};

export default RevealSSNModal;
